import { spacingHelper, radiusHelper, mediaHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';

import { css, styled } from 'styled-components';
import { PropertySearchSection } from './subcomponents/SearchBar/PropertySearchSection';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import heroJpg from '../../../assets/hero.jpg';
import heroAvif from '../../../assets/hero.avif';
import heroMobileJpg from '../../../assets/hero-mobile.jpg';
import heroMobileAvif from '../../../assets/hero-mobile.avif';

const commuteSearchCTAsPadding = css`
  padding: ${spacingHelper('twoExtraLarge')} 0;
  ${mediaHelper('desktopMin')} {
    padding: ${spacingHelper('threeExtraLarge')} 0;
  }
`;

const SearchBrickWrapper = styled.section<{ $addPaddingForCommuteCTAs: boolean }>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: ${spacingHelper('0 extraSmall')};
  min-height: 22.5rem;
  border-radius: ${radiusHelper('extraLarge')};

  ${({ $addPaddingForCommuteCTAs }) => $addPaddingForCommuteCTAs && commuteSearchCTAsPadding};

  ${mediaHelper('tabletMin')} {
    margin: ${spacingHelper('0 large')};
    min-height: 26.25rem;
  }

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  /* For browsers that don't yet support image-set */
  ${mediaHelper('mobile')} {
    background-image: url(${heroMobileJpg});
    background-image: image-set(
      url(${heroMobileAvif}) type('image/avif'),
      url(${heroMobileJpg}) type('image/jpeg')
    );
  }

  /* For browsers that don't yet support image-set */
  ${mediaHelper('tabletMin')} {
    background-image: url(${heroJpg});
    background-image: image-set(
      url(${heroAvif}) type('image/avif'),
      url(${heroJpg}) type('image/jpeg')
    );
  }
`;

export const SearchBrick: FunctionComponent = () => {
  const { isEnabled: isCommuteSearchEnabled } = useFeatureRollout('commute_search');
  const { isEnabled: areCommuteSearchCTAsEnabled } = useFeatureRollout('commute_search_ctas');

  const showCommuteSearchCTAs = isCommuteSearchEnabled() && areCommuteSearchCTAsEnabled();
  return (
    <SearchBrickWrapper $addPaddingForCommuteCTAs={showCommuteSearchCTAs}>
      <PropertySearchSection />
    </SearchBrickWrapper>
  );
};
